__webpack_require__.p = "/trends/";